module.exports = __webpack_public_path__ + "img/04.32107327.png";